<template>
  <v-row no-gutters style="height: 100%; position: relative;">


    <agent-search-dialog 
      ref="agentSearchDialog" 
      :preload="user.agent" 
      title="Choose An Agent"
      @on-save="saveAgent"
    />

    <v-col cols="12" style="position: relative;">
      <v-row no-gutters>
        <v-col class="text-end">
          <v-btn color="primary" @click="sendClientLink" >Send Client Link</v-btn>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col 
          cols="12"
        >
          <v-row no-gutters class="flex-column">
            
            <v-col class="mb-4">
              <div class="title">Info</div>
              <v-card :loading="loading">
                <v-simple-table class="infoTable">
                  <template v-slot:default>
                    <tbody>
                      <tr v-if="$store.getters.userIs('systemAdmin') && user.type == 'USER'">
                        <td><b>Agent</b></td>
                        <td>
                          <v-row no-gutters class="aign=center">
                            <v-col style="width: 300px; max-width: 300px;">
                              {{ (user.agent ? user.agent.full_name : '') }}
                            </v-col>
                            <v-col>
                              <v-btn icon small text color="primary" @click="$refs.agentSearchDialog.open">
                                <v-icon small>mdi-pencil</v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>
                        </td>
                      </tr>
                      <tr>
                        <td><b>Name</b></td>
                        <td>
                          <v-row no-gutters class="align-center">
                            <v-col style="width: 300px; max-width: 300px;">
                              <v-text-field
                                v-if="editingUser"
                                v-model="user.full_name"
                                outlined
                                hide-details
                                dense
                              />
                              <span v-else>{{ user.full_name }}</span>
                            </v-col>
                            <v-col>
                              <v-btn icon small text color="primary" @click="editingUser = !editingUser">
                                <v-icon v-if="editingUser" small>mdi-content-save</v-icon>
                                <v-icon v-else small>mdi-pencil</v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>
                        </td>
                      </tr>
                      <tr>
                        <td><b>Email</b></td>
                        <td>
                          <v-row no-gutters class="align-center">
                            <v-col style="width: 300px; max-width: 300px;">
                              <v-text-field
                                v-if="editingEmail"
                                v-model="user.email"
                                outlined
                                hide-details
                                dense
                              />
                              <span v-else>{{ user.email }}</span>
                            </v-col>
                            <v-col v-if="$store.getters.userIs('systemAdmin') || $store.getters.userIs('employee')">
                              <v-btn icon small text color="primary" @click="editingEmail = !editingEmail">
                                <v-icon v-if="editingEmail" small>mdi-content-save</v-icon>
                                <v-icon v-else small>mdi-pencil</v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>
                        </td>
                      </tr>
                      <tr>
                        <td><b>Mobile Phone</b></td>
                        <td>
                          <v-row no-gutters class="align-center">
                            <v-col style="width: 300px; max-width: 300px;">
                              <v-text-field
                                v-if="editingMobilePhone"
                                v-model="user.mobile_phone"
                                outlined
                                hide-details
                                dense
                              />
                              <span v-else>{{ user.mobile_phone | phonenumber }}</span>
                            </v-col>
                            <v-col>
                              <v-btn icon small text color="primary" @click="editingMobilePhone = !editingMobilePhone">
                                <v-icon v-if="editingMobilePhone" small>mdi-content-save</v-icon>
                                <v-icon v-else small>mdi-pencil</v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>
                        </td>
                      </tr>
                      <tr>
                        <td><b>Home Phone</b></td>
                        <td>
                          <v-row no-gutters class="align-center">
                            <v-col style="width: 300px; max-width: 300px;">
                              <v-text-field
                                v-if="editingHomePhone"
                                v-model="user.meta.home_phone"
                                outlined
                                hide-details
                                dense
                              />
                              <span v-else>{{ getMeta('home_phone') | phonenumber }}</span>
                            </v-col>
                            <v-col>
                              <v-btn icon small text color="primary" @click="editingHomePhone = !editingHomePhone">
                                <v-icon v-if="editingHomePhone" small>mdi-content-save</v-icon>
                                <v-icon v-else small>mdi-pencil</v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>
                        </td>
                      </tr>
                      <tr>
                        <td><b>Work Phone</b></td>
                        <td>
                          <v-row no-gutters class="align-center">
                            <v-col style="width: 300px; max-width: 300px;">
                              <v-text-field
                                v-if="editingWorkPhone"
                                v-model="user.meta.work_phone"
                                outlined
                                hide-details
                                dense
                              />
                              <span v-else>{{ getMeta('work_phone') | phonenumber }}</span>
                            </v-col>
                            <v-col>
                              <v-btn icon small text color="primary" @click="editingWorkPhone = !editingWorkPhone">
                                <v-icon v-if="editingWorkPhone" small>mdi-content-save</v-icon>
                                <v-icon v-else small>mdi-pencil</v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card>
            </v-col>

            <v-col>

              <!--<v-row>
                <v-col
                  cols="12"
                >
                  <div class="title">Households</div>
                  <v-row class="flex-column">
                    <v-col
                      v-for="hh in user.households"
                      :key="'hh' + hh.id"
                    >
                      <v-card>
                        <v-row no-gutters class="flex-nowrap align-center">
                          <v-col class="flex-grow-0 flex-shrink-1 pa-2">
                            <v-icon large>mdi-home</v-icon>
                          </v-col>
                          <v-col>
                            <v-row no-gutters class="flex-column">
                              <v-col class="title">
                                {{ hh.income_monthly }}
                              </v-col>
                              <v-col class="grey lighten-3 caption pa-1">
                                <b>Spouse:</b> {{ (hh.spouse_full_name != '' ? hh.spouse_full_name : '')}}
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>-->

              <household-browser v-if="this.user.households" :household-list="householdIds" />
            </v-col>
          
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import HouseholdBrowser from '@/components/HouseholdBrowser'
import AgentSearchDialog from '@/components/AgentSearchDialog'

export default {
  name: 'UsersView',
  components: {
    HouseholdBrowser,
    AgentSearchDialog
  },
  data: () => ({
    loading: true,
    user: {meta:{}},
    expansions: 'meta,agent,households',

    editingUser: false,
    editingEmail: false,
    editingMobilePhone: false,
    editingHomePhone: false,
    editingWorkPhone: false
  }),
  watch: {
    userId(newVal) {
      if(newVal) this.getDataFromApi()
    },
    editingUser (newVal) {
      if(!newVal) this.saveUserName()
    },
    editingEmail (newVal) {
      if(!newVal) this.saveEmail()
    },
    editingMobilePhone (newVal) {
      if(!newVal) this.saveMobilePhone()
    },
    editingHomePhone (newVal) {
      if(!newVal) this.saveHomePhone()
    },
    editingWorkPhone (newVal) {
      if(!newVal) this.saveWorkPhone()
    }
  },
  mounted() {
    this.getDataFromApi()
  },
  computed: {
    userId() {
      return this.$route.params.user_id
    },
    householdIds() {
      let arr = []
      for(let i = 0; i < this.user.households.length; i++) {
        arr.push(this.user.households[i].id)
      }
      return arr
    }
  },
  methods: {
    sendClientLink(){

      if(this.userId){
        this.$http.post('household-customer-data/send-email',  {id:this.userId, email:this.$root.currentUser.email})
            .then(() => {
              this.$swal.fire({
                title: 'Email is send',
                icon: 'success',
                showCancelButton: false,
                showConfirmButton: true
              })
            })
            .catch(err => {
              console.log(err.response)
              this.$swal.fire('Error', 'Email is not send')
              this.$router.go(-1)
            })
      }
    },
    getDataFromApi() {
      this.loading = true;

      let queryParams = []
      queryParams.push('expand=' + this.expansions)

      this.$http.get('users/' + this.userId + '?' + queryParams.join('&'))
        .then(response => {
          this.user = response.data
        })
        .catch(err => {
          console.log(err.response)
          this.$swal.fire('Error', 'There was an error loading User ID ' + this.userId, 'error')
          this.$router.go(-1)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getMeta(key) {
      if(!this.user || !this.user.id || !this.user.meta) return ''
      /*for(let i = 0; i < this.user.meta.length; i++) {
        if(this.user.meta[i].name == key) return this.user.meta[i].value
      }*/
      return this.user.meta[key]
    },
    saveUserName() {
      let name        = (this.user.full_name || '').split(' ')
      let first_name  = ''
      let last_name   = ''
      if(name[1]) {
        first_name  = name.shift()
        last_name   = name.join(' ')
      } else {
        first_name  = name[0]
      }

      let queryParams = []
      queryParams.push('expand=' + this.expansions)
      let data = {
        first_name: first_name,
        last_name: last_name
      }
      this.$http.put('users/' + this.userId + '?' + queryParams.join('&'), data)
        .then(response => {
          this.user        = response.data
        })
        .catch(() => {
          this.$swal.fire('Error', 'There was an error saving the user', 'error')
        })
      
    },
    saveAgent(data, confirm) {
      if(this.user.type != 'USER') return
      let id = data.id
      if(!id || id == this.user.agent_id) return

      let queryParams = []
      queryParams.push('expand=' + this.expansions)
      let params = {
        agent_id: id
      }
      if(confirm) params.confirm = 1
      this.$http.post('users/' + this.userId + '/change-agent?' + queryParams.join('&'), params)
        .then(response => {
          if(response.data.needs_confirmation) {
            this.$swal.fire({
              title: 'Please Confirm',
              html: response.data.confirmation_html,
              icon: 'warning',
              cancelButtonText: 'Cancel',
              confirmButtonText: 'Update All'
            }).then(conf => {
              if(conf.value) this.saveAgent(data, 1)
            })
          } else {
            this.user = response.data
          }
        })
        .catch(err => {
          console.log(err.response)
          this.$swal.fire('Error', 'There was an error processing your request. Please try again.', 'error')
        })
    },
    saveEmail() {
      let queryParams = []
      queryParams.push('expand=' + this.expansions)
      let data = {
        email: this.user.email,
        verifyEmail: 1
      }
      this.$http.put('users/' + this.userId + '?' + queryParams.join('&'), data)
        .then(response => {
          this.user        = response.data
        })
        .catch(err => this.handleError(err))
      
    },
    saveMobilePhone() {
      let queryParams = []
      queryParams.push('expand=' + this.expansions)
      let data = {
        mobile_phone: this.user.mobile_phone,
        mobile_phone_country: 'US'
      }
      this.$http.put('users/' + this.userId + '?' + queryParams.join('&'), data)
        .then(response => {
          this.user        = response.data
        })
        .catch(err => this.handleError(err))
    },
    saveHomePhone() {
      let queryParams = []
      queryParams.push('expand=' + this.expansions)
      let data = {
        setMeta: {
          home_phone: this.user.meta.home_phone
        }
      }
      this.$http.put('users/' + this.userId + '?' + queryParams.join('&'), data)
        .then(response => {
          this.user        = response.data
        })
        .catch(err => this.handleError(err))
    },
    saveWorkPhone() {
      let queryParams = []
      queryParams.push('expand=' + this.expansions)
      let data = {
        setMeta: {
          work_phone: this.user.meta.work_phone
        }
      }
      this.$http.put('users/' + this.userId + '?' + queryParams.join('&'), data)
        .then(response => {
          this.user        = response.data
        })
        .catch(err => this.handleError(err))
    },
    handleError(err) {
      let message = err.response.statusText
      if(err.response.status == 422) {
        message = ''
        for(let i = 0; i < err.response.data.length; i++) {
          message += err.response.data[i].message + '<br>'
        }
        this.getDataFromApi()
      }
      this.$swal.fire('Error', message, 'error')
    }
  }
}
</script>

<style lang="scss" scoped>
  .infoTable {
    tbody {
      tr {
        td {
          &:first-child {
            width: 130px;
          }
        }
      }
    }
  }
</style>